//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// EXPORT
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// A simple javascript file that contains static functions for exporting
// data to be saved as csv on users' computers.
//
// Author: Frederick.Pierce@usda.gov
// For: NRCS/ASRC/CPDES
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

export function exportCsvDTO(DTO, objectName, typeCode) {
    const BOM = '\uFEFF';
    var blob = new Blob([BOM + DTO], { type: 'text/csv;charset=utf-8;' });
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, `${objectName}-Export-${typeCode}.csv`);
    }
    else {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${objectName}-Export-${typeCode}.csv`;
        link.click();
    }
}